import React from "react";
import { Container, Grid, Box } from "@mui/material";
import List from "./inc/List";
import AddForm from "./inc/AddForm";
import CcpAdminBreadCrumbs from "../../Layout/CcpAdminBreadCrumbs";
import { faBullhorn } from "@fortawesome/free-solid-svg-icons"; // Changed icon for relevance
import useFirestore from "../../../config/fireBaseHook"; // Import the hook

const CcpAdminAnnouncements = () => {
  const pageName = "Announcements";
  const icon = faBullhorn; // Using a more relevant icon

  // Use the firestore hook for the 'Announcements' collection
  const { data, loading, error, addData, updateData, deleteData } =
    useFirestore("Announcements", "expireDate", "desc");

  return (
    <Container sx={{ marginTop: "100px" }}>
      <Box sx={{ flexGrow: 1 }}>
        <CcpAdminBreadCrumbs pageName={pageName} icon={icon} />
        <Grid container spacing={2} sx={{ marginTop: "10px" }}>
          {/* Add Form - Pass addData function */}
          <Grid item xs={12} md={12}>
            {" "}
            {/* Adjusted grid size for responsiveness */}
            <AddForm addData={addData} />
          </Grid>
          {/* List - Pass data, loading, error, updateData, deleteData */}
          <Grid item xs={12} md={12}>
            {" "}
            {/* Adjusted grid size for responsiveness */}
            <List
              data={data}
              loading={loading}
              error={error}
              updateData={updateData}
              deleteData={deleteData}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpAdminAnnouncements;
